
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import LabTestMultiSelector from "./LabTestMultiSelector";

const MyLab = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <LabTestMultiSelector />
      </div>
    </div>
  );
};

export default MyLab;
